module.exports = __webpack_public_path__ + "img/breadcrumb.88fff310.svg";